import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '电影大全', path: '/category/movie' },
    { label: '电视剧', path: '/category/tv' },
    { label: '热门综艺', path: '/category/variety' },
    { label: '动漫番剧', path: '/category/anime' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户口碑', path: '/about#reputation' },
  ],
  友情链接: [
    { label: '豆瓣电影', path: 'https://movie.douban.com' },
    { label: 'IMDb', path: 'https://www.imdb.com' },
    { label: '烂番茄', path: 'https://www.rottentomatoes.com' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-lg text-background-50 dark:text-foreground-950"></i>
              </div>
              <span className="text-xl font-heading text-foreground-50 font-bold">八戒影视</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              八戒影视网提供最新高清电影、热播电视剧、热门综艺和动漫免费在线观看。播放流畅不卡顿，秒速加载不缓冲，为您带来极致的观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith('http') ? (
                      <a
                        href={link.path}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-200/60">
        <div className="w-full px-4 md:px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-xs text-foreground-600">
              &copy; 2026 八戒影视网 bajieying.com 版权所有
            </p>
            <p className="text-xs text-foreground-600">
              本站内容均来自网络，仅供学习交流，请勿用于商业用途
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}